import { configs } from '../configs';

export const configService =
  configs[import.meta.env.VITE_TE_APP_ENV || 'development'];
